<template>
  <div
    class="riepilogo-ferie-mobile mobile_customize col-xs-24"
    :style="{ height: (tableHeight) + 'px'}"
    v-loading="loading"
  >

    <div class="row row-custom">  
      <div class="mobile-title col-24 no-padding">{{ $t('ferie.titolo') }}</div>
    </div>
    <div class="row row-custom">
      <div class="col-24 no-padding">
        <div class="box" :style="{ height: (tableHeight-20) + 'px'}">
          <!--<div class="action">
            <span @click="today">today</span>
          </div>
          <span @click="goToNuovaRichiesta">news</span>
          <span @click="changeView('L')">list</span>
          <span @click="changeView('M')">month</span>-->
          <FullCalendar
            :selectable="true"
            defaultView="dayGridMonth"
            :header= "{
              left: 'prev',
              center: 'title',
              right: 'next'
            }"
            @datesRender="handleMonthChange"
            :plugins="calendarPlugins"
            :eventRender="eventRender"
            :events="richiesteCalendar"
            @dateClick="dateClick"
            @select="select"
            :selectLongPressDelay="0"
            ref="fullCalendar"
            :locale=config.locale
            :firstDay=config.firstDay
          />
          <div class="residuo-ferie">
            <div class="elemento row row-custom">
              <div class="res-label col-4 no-padding center">{{ $t('ferie.resAp') }}</div>
              <div class="res-label col-4 no-padding center">{{ $t('ferie.resAc') }}</div>
              <div class="res-label col-4 no-padding center">{{ $t('ferie.resRh1') }}</div>
              <div class="res-label col-4 no-padding center">{{ $t('ferie.resRh2') }}</div>
              <div class="res-label col-4 no-padding center">{{ $t('ferie.resRh3') }}</div>
              <div class="res-label col-4 no-padding center">{{ $t('ferie.resRh4') }}</div>
              <div class="res-separate col-24 no-padding"></div>
              <div class="res-value col-4 no-padding">{{resAp}}</div>
              <div class="res-value col-4 no-padding">{{resAc}}</div>
              <div class="res-value col-4 no-padding">{{resRh1}}</div>
              <div class="res-value col-4 no-padding">{{resRh2}}</div>
              <div class="res-value col-4 no-padding">{{resRh3}}</div>
              <div class="res-value col-4 no-padding">{{resRh4}}</div>
            </div>
          </div>
          <!--<el-calendar v-model="value">
           <template
              slot="dateCell"
              slot-scope="{date, data}" >
              <div>
                <div class="calendar-day">{{ data.day.split('-').slice(2).join('-') }}</div>
                <div v-for="(item,index) in richieste" :key='index'>

                </div>
              </div>
            </template>
          </el-calendar>-->
          <div class="elenco-ferie">
            <div v-for="(item,index) in richiesteDay" :key="index" class="scheda" :class="item.tipoAssenza === 'RCR' ? 'RCR_' + item.stato : item.stato">
              <div class="day" :class="item.tipoAssenza === 'RCR' ? 'RCR' : ''">
                <span v-if="item.dataDal === item.dataAl">
                  {{$t('ferie.mesi.'+ item.dataDal.substring(4,6), {day:item.dataDal.substring(6,8), year:item.dataDal.substring(0,4)} )}}
                </span>
                <span v-else>
                  {{$t('ferie.mesi.'+ item.dataDal.substring(4,6), {day:item.dataDal.substring(6,8), year:item.dataDal.substring(0,4)} )}} - 
                  {{$t('ferie.mesi.'+ item.dataAl.substring(4,6), {day:item.dataAl.substring(6,8), year:item.dataAl.substring(0,4)} )}}
                </span>
                <span v-if="item.tipoAssenza === 'RCR'" class="orario">
                  {{item.oraIni | formatHours}} - {{item.oraFin | formatHours}}
                </span>
                <icon v-if="(item.seGest === 'S')" class="pointer" name="riv-delete2" scale="2"
                          @click.native="deleteRichiesta(item)"></icon>
                <icon v-if="(item.notaDip !== '' || item.notaResp !== '' )" class="pointer" name="riv-addnotes" scale="2" @click.native="showNote(item)" 
                :style="[item.seGest === 'S' ? {'margin-right': '20px'} : {'margin-right': '5px'}]"
                ></icon>
              </div>
              <span class="tipo">
                {{item.descTipoAssenza}}
              </span>
              <!--<span class="note">
                {{item.notaDip}}
              </span>
              <span class="note">
                {{item.notaResp}}
              </span>-->
            </div>
          </div>
          <div class="add"> 
            <icon name="riv-add_2" scale="3" flip="horizontal"
                @click.native="goToNuovaRichiesta" class="pointer"></icon>
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog di creazione di una nuova richiesta di ferie -->
    <el-dialog
      :title="($t('ferie.titoloNuovaRichiesta').toUpperCase())"
      :visible.sync="showNuovaRichiesta"
      class="el-dialog_mobile dialog-ferie-mobile mobile_customize"
      :append-to-body="true"
      custom-class="col-24"
      v-loading="loading_Save"
    >
      <el-form class>
        <div class="elemento row row-custom">
          <div class="my-label col-24 no-padding">{{ $t('ferie.tipologia') }}</div>
          <div class="my-value col-24 no-padding">
            <div class="select-wrapper">
              <select v-model="form.tipoAssenza">
                <option
                  v-for="(item, index) in tipiAssenza"
                  :value="item"
                  :key="index"
                >{{ item.descrizione }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-12 padding-left">{{ $t('ferie.dataDa') }}</div>
          <div class="my-label col-12 padding-right">{{ $t('ferie.dataA') }}</div>
          
          <div class="my-value col-12 padding-left">
            <div class="input-wrapper">
              <input type="date" v-model="form.dataDal" />
            </div>
          </div>
          <div class="my-value col-12 padding-right">
            <div class="input-wrapper">
              <input type="date" v-model="form.dataAl" />
            </div>
          </div>
        </div>
        <div v-if="form.tipoAssenza.seOre === 'S'" class="elemento row row-custom">
          <div class="my-label col-6 no-padding center">{{ $t('ferie.hhInizio') }}</div>
          <div class="my-label col-6 no-padding center">{{ $t('ferie.mmInizio') }}</div>
          <div class="my-label col-6 no-padding center">{{ $t('ferie.hhFine') }}</div>
          <div class="my-label col-6 no-padding center">{{ $t('ferie.mmFine') }}</div>
          <div class="my-value col-6 no-padding">
            <div class="select-wrapper time-first">
              <select v-model="form.oraIni">
                <option
                  v-for="(hour, index) in hours"
                  :value="hour"
                  :key="index"
                >{{ hour }}</option>
              </select>
            </div>
          </div>
           <div class="my-value col-6 no-padding">
            <div class="select-wrapper time-first">
               <select v-model="form.minutiIni">
                <option
                  v-for="(minute, index) in minutes"
                  :value="minute"
                  :key="index"
                >{{ minute }}</option>
              </select>
            </div>
          </div>
          <div class="my-value col-6 no-padding">
            <div class="select-wrapper time-second">
              <select v-model="form.oraFin">
                <option
                  v-for="(hour, index) in hours"
                  :value="hour"
                  :key="index"
                >{{ hour }}</option>
              </select>
            </div>
          </div>
           <div class="my-value col-6 no-padding">
            <div class="select-wrapper time-second">
               <select v-model="form.minutiFin">
                <option
                  v-for="(minute, index) in minutes"
                  :value="minute"
                  :key="index"
                >{{ minute }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-24 no-padding">{{ $t('ferie.noteDip') }}</div>
          <div class="col-24 no-padding">
            <el-input
              type="text"
              maxlength="60"
              placeholder=""
              v-model="form.notaDip"
            ></el-input>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          class="mobile-el-button primary"
          type="primary"
          @click="confermaRichiesta"
        >{{ $t('btn.conferma') }}</el-button>
        <el-button
          class="mobile-el-button secondary"
          @click="showNuovaRichiesta = false"
        >{{ $t('btn.annulla') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {bus} from '@/components/Bus.js'
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import moment from 'moment'

export default {
  name: "RiepilogoFerieBEMobile",
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  props: ["tableHeight"],
  data() {
    return {
      calendarPlugins: [dayGridPlugin, listPlugin, interactionPlugin],
      value: new Date(),
      loading: false,
      loading_Save: false,
      currentPage: 1,
      pag_for: 999,
      nrItems: 0,
      anno: 0,
      richieste: [],
      richiesteDay: [],
      richiesteCalendar: [],
      mapRCR: {},
      resAc: '',
      resAp: '',
      resRh1: '',
      resRh2: '',
      resRh3: '',
      resRh4: '',
      //anni: [],
      showNuovaRichiesta: false,
      tipiAssenza: [],
      form: {
        tipoAssenza: "",
        dataDal: "",
        dataAl: "",
        oraIni: "",
        minutiIni: "",
        oraFin: "",
        minutiFin: "",
        notaDip: "",
        periodo: []
      },
      oreDisabled: true,
      visibleInfo: false,
      notaDip: "",
      notaResp: "",
      hours: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23'
      ],
      minutes: ['00','05','10','15','20','25','30','35','40','45','50','55'],
      config: {
        locale: this.setLocale(),
        firstDay:1
      }
    }
  },
  activated: function() {
    this.today()
    this.getTipiAssenza()
  },
  deactivated: function() {
    this.loading = false
    this.loading_Save = false
    this.anno = 0
    this.$set(this, 'richieste', [])
    this.$set(this, 'richiesteDay', [])
    this.$set(this, 'richiesteCalendar', [])
    this.$set(this, 'mapRCR', {})
    this.resAc = ''
    this.resAp = ''
    this.resRh1 = ''
    this.resRh2 = ''
    this.resRh3 = ''
    this.resRh4 = ''
    this.showNuovaRichiesta = false
    this.$set(this, 'tipiAssenza', [])
    let form = {
        tipoAssenza: "",
        dataDal: "",
        dataAl: "",
        oraIni: "",
        minutiIni: "",
        oraFin: "",
        minutiFin: "",
        notaDip: "",
        periodo: []
      }
      this.$set(this, 'form', form)
      this.oreDisabled = true
      this.visibleInfo = false
      this.notaDip = ""
      this.notaResp = ""
  },
  filters: {
    formatDate: function(date) {
      if (date !== "") {
        return (
          date.substr(6, 2) + "/" + date.substr(4, 2) + "/" + date.substr(0, 4)
        );
      } else {
        return "-";
      }
    },
    formatHours: function(value) {
      if (value !== "") {
        return value.replace(/,/g, '.')
      } else {
        return ""
      }
    }
  },
  methods: {
    handleMonthChange: function(arg) {
      var currentStart = arg.view.currentStart;
      var check = moment(currentStart, "YYYY/MM/DD");
      var currentYear = check.format("YYYY");
      if (currentYear !== this.anno) {
        this.anno = currentYear
        this.getRiepilogoFerie()
      }
      // load action
      //this.updateCurrentMonth(currentMonth);
      // refresh summaries
      //this.updateSummary();
    },
    today: function() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.today()
      let anno = moment(calendarApi.state.currentDate).format("YYYY")
      if (anno !== this.anno) {
        this.anno = anno
        this.getRiepilogoFerie()
      }
    },
    changeView: function(type) {
      let calendarApi = this.$refs.fullCalendar.getApi();
      if (type === "L") {
        calendarApi.changeView("listMonth");
        this.richieste = this.richieste.map(function(obj) {
          obj.rendering = "";
          return obj;
        });
      } else {
        calendarApi.changeView("dayGridMonth");
        this.richieste = this.richieste.map(function(obj) {
          obj.rendering = "background";
          return obj;
        });
      }
    },
    dateClick: function(info) {
      this.richiesteDay = this.richieste.filter(function(obj) {
        let start = obj.start.substring(0, 10);
        let end = obj.end.substring(0, 10);
        if (start <= info.dateStr && end >= info.dateStr) {
          return obj;
        }
      });
      console.log(this.richiesteDay);
    },
    select: function(info) {
      console.log("dateClick");
      console.log(info);
    },
    eventRender: function(info) {
      //console.log("eventRender")
      //console.log(info.view.currentStart);
      //info.el.textContent = info.event.title
      info.el.textContent = info.event.extendedProps.num
      if (info.event.title === "CAM" || info.event.title === "CEM") {
        info.el.className = info.el.className + " POM " + info.event.extendedProps.stato;
      } else if (info.event.title === "CMA" | info.event.title === "CME") {
        info.el.className = info.el.className + " MAT " + info.event.extendedProps.stato;
      } else if (info.event.title === "CPX") {
        info.el.className = info.el.className + " CPX " + info.event.extendedProps.stato;
      } else if (info.event.title === "RCR") {
        info.el.className = info.el.className + " RCR " + info.event.extendedProps.stato;
      }
    },
    inviaRichiesta: function(rinunciaFraz) {
      let obj = {}
      if (this.form.dataAl === '' &&  this.form.dataDal === '' ) {
        this.$message({
          showClose: true,
          message: this.$i18n.t("ferie.errorNoPeriodo"),
          type: "error",
          duration: process.env.duration
        });
      } else {
        this.loading_Save = true
        obj.rinunciaFraz = rinunciaFraz;
        obj.operazione = "*ADD";
        obj.oraIni = this.form.tipoAssenza.seOre === 'S' ? (this.form.oraIni + '.' + this.form.minutiIni + '.00' ) : '00.00.00'
        obj.oraFin = this.form.tipoAssenza.seOre === 'S' ? (this.form.oraFin + '.' + this.form.minutiFin + '.00' ) : '00.00.00'
        obj.dataDal = this.form.dataDal.replace(/-/g,"")
        obj.dataAl = this.form.dataAl.replace(/-/g,"")
        obj.tipoAssenza = this.form.tipoAssenza.tipo
        obj.notaDip = this.form.notaDip
        this.$http.post('ferie/' + this.$store.state.country + "/richiesta", obj
          )
          .then(response => {
            if (response.body.rc === 0) {
              this.showNuovaRichiesta = false;
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: "success",
                duration: process.env.duration
              });
              this.loading_Save = false
              this.getRiepilogoFerie()
            } else {
              this.loading_Save = false
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: "error",
                duration: process.env.duration
              });
            }
          });
      }
    },
    confermaRichiesta: function() {
      let seFraz = "";
      /*for (let i = 0; i < this.tipiAssenza.length; i++) {
        if (this.tipiAssenza[i].tipo === this.form.tipoAssenza) {
          seFraz =
            this.tipiAssenza[i].seFraz === undefined
              ? "S"
              : this.tipiAssenza[i].seFraz;
        }
      }*/
      if (this.form.tipoAssenza.seFraz === "S") {
        this.$confirm(
          this.$i18n.t("ferie.ifInviaRichiesta"),
          this.$i18n.t("ferie.attenzione"),
          {
            confirmButtonText: this.$i18n.t("ferie.si"),
            cancelButtonText: this.$i18n.t("ferie.no"),
            type: "warning",
            showClose: false,
            closeOnClickModal: false,
            customClass: 'el-message-box-mobile'
          }
        )
          .then(() => {
            this.inviaRichiesta("1");
          })
          .catch(() => {
            this.inviaRichiesta("0");
          });
      } else {
        this.inviaRichiesta("0");
      }
    },
    changeTipoAssenza: function(tipoAssenza) {
      this.tipiAssenza.forEach(item => {
        if (item.tipo === tipoAssenza) {
          this.oreDisabled = item.seOre !== "S";
          if (this.oreDisabled === true) {
            this.$set(this.form, "oraIni", "");
            this.$set(this.form, "oraFin", "");
          }
        }
      });
    },
    goToNuovaRichiesta: function() {
      this.$set(this, "form", {});
      this.$set(this.form, "dataDal", "");
      this.$set(this.form, "dataAl", "");
      this.$set(this.form, "oraIni", "");
      this.$set(this.form, "minutiIni", "");
      this.$set(this.form, "oraFin", "");
      this.$set(this.form, "minutiFin", "");
      this.$set(this.form, "tipoAssenza", this.tipiAssenza[0]);
      //this.$set(this.form, 'tipoAssenza', response.body.data[0].tipo)
      this.$set(this, "showNuovaRichiesta", true);
    },
    elimina: function(richiesta) {
      this.loading_Save = true
      this.$http.delete('ferie/' +this.$store.state.country +"/richiesta",
          {
            params: {
              id: richiesta.id
            }
          }
        )
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: "success",
              duration: process.env.duration
            });
            this.$set(this, "currentPage", 1);
            this.loading_Save = true
            this.getRiepilogoFerie();
          } else {
            this.loading_Save = true
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: "error",
              duration: process.env.duration
            });
          }
        });
    },
    deleteRichiesta: function(richiesta) {
      this.$confirm(
        this.$i18n.t("ferie.ifDelete"),
        this.$i18n.t("ferie.attenzione"),
        {
          confirmButtonText: this.$i18n.t("btn.elimina"),
          cancelButtonText: this.$i18n.t("btn.annulla"),
          type: "warning",
          customClass: 'el-message-box-mobile'
        }
      )
        .then(() => {
          this.elimina(richiesta);
        })
        .catch(() => {
          // Eventuale handler di annullamento cancellazione
        });
    },
    showNote: function (row) {
      //this.notaDip = row.notaDip
      //this.notaResp = row.notaResp
      let message = ''
      message += row.notaDip !== '' ? '<strong>' + this.$i18n.t('ferie.dip') + '</strong><br>' + row.notaDip + '<br>' : ''
      message += row.notaResp !== '' ? '<strong>' + this.$i18n.t('ferie.resp') + '</strong><br>' + row.notaResp : ''
      this.$alert(message, this.$i18n.t('ferie.note'), {
          confirmButtonText: 'OK',
          customClass: 'el-message-box-mobile',
          dangerouslyUseHTMLString: true
        });
    },
    changeAnno: function(op) {
      this.anno = this.anno + op;
      this.getRiepilogoFerie();
    },
    changePage: function(page) {
      this.$set(this, "currentPage", page);
      this.getRiepilogoFerie();
    },
    getRiepilogoFerie: function() {
      this.loading = true
      this.$set(this, "richieste", []);
      this.$set(this, "richiesteCalendar", []);
      this.$set(this, "mapRCR", {});
      this.$http.get('ferie/' + this.$store.state.country + "/ferie",
          {
            params: {
              pag_action: this.currentPage === 1 ? "BEGIN" : "NEXT",
              pag_for: this.pag_for,
              pag_from: this.currentPage,
              anno: this.anno
            }
          }
        )
        .then(response => {
          if (response.body.rc === 0) {
            if (response.body.hasOwnProperty("attrib")) {
              this.$set(this, 'resAp', response.body.attrib.resAp)
              this.$set(this, 'resAc', response.body.attrib.resAc)
              this.$set(this, 'resRh1', response.body.attrib.resRh1)
              this.$set(this, 'resRh2', response.body.attrib.resRh2)
              this.$set(this, 'resRh3', response.body.attrib.resRh3)
              this.$set(this, 'resRh4', response.body.attrib.resRh4)
            }
            if (response.body.hasOwnProperty("data")) {

              this.richieste = response.body.data.map(function(obj) {
                obj.title = obj.tipoAssenza
                obj.start =
                  obj.dataDal.slice(0, 4) +
                  "-" +
                  obj.dataDal.slice(4, 6) +
                  "-" +
                  obj.dataDal.slice(6, 8) +
                  "T00:00:00.000Z";
                obj.end =
                  obj.dataAl.slice(0, 4) +
                  "-" +
                  obj.dataAl.slice(4, 6) +
                  "-" +
                  obj.dataAl.slice(6, 8) +
                  "T23:59:00.000Z";
                obj.allDay = true;
                //if (obj.tipoAssenza !== 'RCR'){
                obj.rendering = "background";
                //}
                return obj;
              });

              for (let key in this.richieste) {
                let obj = this.richieste[key]
                let objCal = {}
                  objCal.title = obj.tipoAssenza
                  objCal.start = obj.dataDal.slice(0, 4) + "-" + obj.dataDal.slice(4, 6) + "-" + obj.dataDal.slice(6, 8) + "T00:00:00.000Z";
                  objCal.end = obj.dataAl.slice(0, 4) + "-" + obj.dataAl.slice(4, 6) + "-" + obj.dataAl.slice(6, 8) + "T23:59:00.000Z";
                  objCal.allDay = true;
                  objCal.rendering = "background";
                  objCal.stato = obj.stato
                  objCal.seOre = obj.seOre
                if (obj.seOre !== 'S') {
                  this.richiesteCalendar.push(objCal)
                } else {
                  if (this.mapRCR[obj.dataDal] === undefined){
                    objCal.num = 1
                    this.mapRCR[obj.dataDal] = objCal
                  } else {
                    objCal = this.mapRCR[obj.dataDal]
                    objCal.num = objCal.num + 1
                    objCal.stato = "MULTI"
                    this.mapRCR[obj.dataDal] = objCal
                  }
                }
              }
              /*
              this.richiesteCalendar = this.richieste.map(function(obj) {
                let objCal = {}
                  objCal.title = obj.tipoAssenza
                  objCal.start = obj.dataDal.slice(0, 4) + "-" + obj.dataDal.slice(4, 6) + "-" + obj.dataDal.slice(6, 8) + "T00:00:00.000Z";
                  objCal.end = obj.dataAl.slice(0, 4) + "-" + obj.dataAl.slice(4, 6) + "-" + obj.dataAl.slice(6, 8) + "T23:59:00.000Z";
                  objCal.allDay = true;
                  objCal.rendering = "background";
                  objCal.stato = obj.stato
                if (obj.tipoAssenza !== 'RCR') {
                  return objCal
                } else {
                  if (_this.mapRCR[obj.dataDal] === undefined){
                    objCal.num = 1
                    _this.mapRCR[obj.dataDal] = objCal
                  } else {
                    objCal = _this.mapRCR[obj.dataDal]
                    objCal.num = objCal.num + 1
                    objCal.stato = "MULTI"
                    _this.mapRCR[obj.dataDal] = objCal
                  }
                }
              });
              */
              for (const property in this.mapRCR) {
                this.richiesteCalendar.push(this.mapRCR[property])
              }
            } else {
              this.$set(this, "richieste", []);
              this.$set(this, "richiesteCalendar", []);
              this.$set(this, "mapRCR", {});
            }

            /*
              if (response.body.hasOwnProperty('data')) {
                this.$set(this, 'richieste', response.body.data)
              } else {
                this.$set(this, 'richieste', [])
              }
              if (this.currentPage === 1) {
                this.$set(this, 'resCpNap', response.body.attrib.resCpNap)
                this.$set(this, 'resCpN', response.body.attrib.resCpN)
                this.$set(this, 'resRcr', response.body.attrib.resRcr)
                this.$set(this, 'nrItems', (response.body.attrib.size !== '') ? parseInt(response.body.attrib.size) : 0)
              } */
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: "error",
              duration: process.env.duration
            });
          }
          this.loading = false;
        });
    },
    getTipiAssenza: function() {
      this.$http.get('ferie/' +this.$store.state.country + "/tipiassenza"
        )
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, "tipiAssenza", response.body.data);
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: "error",
              duration: process.env.duration
            });
          }
        });
    },
    setLocale: function (){
      let localconf = {
        fr_FR: 'fr',
        it_IT: 'it',
        es_ES: 'es',
        de_DE: 'de',
        en_GB: 'en'
      }
      return localconf[this.$store.state.country]
    }
  }
};
</script>


<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/mobile_customize.less";
@import "../../assets/less/el-dialog_mobile";
@import "@fullcalendar/core/main.css";
@import "@fullcalendar/daygrid/main.css";

.riepilogo-ferie-mobile {
  padding: 0;

  .add {
    position: fixed;
    right: 20px;
    bottom: 20px;
    color: #FF791A;
  }

  .action {
    height: 20px;
    line-height: 20px;
    span {
      float: right;
      .set-font(@size: 14px, @color: @grayDark, @weight: bold, @family:'os-regular');
      text-transform: capitalize;
      padding-right: 15px;
    }
  }

  .residuo-ferie{
    margin-top: 5px;
    .res-label {
      .set-font(@size: 14px, @color: @oroRiva, @weight: bold, @family:'os-regular');
      text-align: center;
      letter-spacing: 2px;
      height: 22px;
    }
    .res-value {
      .set-font(@size: 14px, @color: @grayMedium, @weight: bold, @family:'os-regular');
      text-align: center;
      height: 22px;
    }
    .res-separate {
      border-bottom: 1px solid #dddddd;
      margin-bottom: 2px;
    }
  }
  .elenco-ferie {
    .scheda {
      border-radius: 5px;
      height: 100px;
      margin-bottom: 5px;
      margin-top: 5px;
      border: 1px solid #dddddd;
      .day {
        width: 100%;
        height: 30px;
        .set-font(@size: 13px, @color: @greenRiva, @weight: bold, @family:'os-regular');
        padding-left: 5px;
        span {
          float: left;
          line-height: 30px;
        }
        .fa-icon {
          float: right;
          height: 30px;
        }
        .orario {
          padding-left: 10px;
          color: @greenTick;
        }
      }
      .tipo {
        .set-font(@size: 13px, @color: @grayTesto, @family:'os-regular');
        padding-left: 5px;
        text-align: left;
        display: block;
      }
      .note {
        .set-font(@size: 13px, @color: @grayDark, @family:'os-regular');
        padding-left: 5px;
        text-align: left;
        display: block;
      }
      &.A {
        border-left: 5px solid @orangeMedium;
      }
      &.C {
        border-left: 5px solid #c9db96;
      }
      &.R {
        border-left: 5px solid #f44336;
      }
      &.RCR_A {
        border-left: 5px solid @orangeMedium;
      }
      &.RCR_C {
        border-left: 5px solid #c9db96;
      }
      &.RCR_R {
        border-left: 5px solid #f44336;
      }
    }
  }

  .fc-header-toolbar {
    .fc-today-button {
      background-color: transparent;
      color: @grayDark;
      border: none;
      text-transform: capitalize;
    }
    .fc-prev-button,.fc-next-button  {
      background-color: transparent;
      border: none;
      span {
        color: #007c74;
        font-size: 20px;
      }
    }
  }

  .fc-head {
    table {
      border-collapse: separate;
      border-spacing: 3px;
      thead {
        tr {
          th {
            border: none;
          }
        }
      }
    }
  }
  .fc-body {
    .fc-scroller {
      height: 100% !important;

      .fc-day-grid {

        table {
          border-collapse: separate;
          border-spacing: 3px;
        }

        .fc-highlight-skeleton {
          table {
            tbody {
              tr {
                .fc-highlight{
                  background: none;
                  background-color: rgba(21, 129, 171, 0.25);
                  border: 1px solid rgba(61,145,177,0)!important;
                  box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgb(59, 124, 120);
                }
              }
            }
          }
        }
        
      }

      .fc-bgevent {
        padding-top: 15px;
        color: black;
        &.POM {
          border: none;
          &.A {
            opacity: 1;
            background: linear-gradient(
              hsla(0, 0%, 100%, 0) 50%,
              rgba(245, 172, 84, 1) 0
            );
          }
          &.C {
            opacity: 1;
            background: linear-gradient(
              hsla(0, 0%, 100%, 0) 50%,
              rgba(201, 219, 150, 1) 0
            );
          }
          &.R {
            opacity: 1;
            background: linear-gradient(
              hsla(0, 0%, 100%, 0) 50%,
              rgba(244, 67, 54, 1) 0
            );
          }
        }
        &.MAT {
          border: none;
          &.A {
            opacity: 1;
            background: linear-gradient(
            rgba(245, 172, 84, 1) 50%,
            hsla(0, 0%, 100%, 0) 0
            );
          }
          &.C {
            opacity: 1;
            background: linear-gradient(
            rgba(201, 219, 150, 1) 50%,
            hsla(0, 0%, 100%, 0) 0
            );
          }
          &.R {
            opacity: 1;
            background: linear-gradient(
            rgba(244, 67, 54, 1) 50%,
            hsla(0, 0%, 100%, 0) 0
            );
          }
        }
        &.CPX {
          opacity: 1;
          &.A {
            background: rgba(245, 172, 84, 1)
          }
          &.C {
            background: rgba(201, 219, 150, 1)
          }
          &.R {
            background: rgba(244, 67, 54, 1)
          }
        }
        &.RCR {
          opacity: 1;
          background: transparent;
          background-repeat: no-repeat;
          background-size: 100%;
          color: white;
          text-align: center;
          &.A {
            background-image: url("../../../static/img/permit_Badge_A.png");
          }
          &.C {
            background-image: url("../../../static/img/permit_Badge_C.png");
          }
          &.R {
            background-image: url("../../../static/img/permit_Badge_R.png");
          }
          &.MULTI {
            background-image: url("../../../static/img/permit_Badge.png");
          }
        }
      }

      background: #fff;
    }
  }
}

  .dialog-ferie-mobile {
    .elemento {
      .padding-left {
      padding-right: 10px;
      padding-left: 0px;
      }
      .padding-right{
      padding-right: 0px;
      padding-left: 10px;
      }
    }
    .input-wrapper {
      height: 38px;
      input {
        height: 38px;
        width: 100%;
        padding-right: 24px;
        background-color: #fff;
        border-radius: 5px;
        border-color: #969696;
        font-size: 18px;
        text-align: center;
        color: #969696;
        // margin: 3px;
        padding: 3px;
        -webkit-appearance: none;
        &.first {
          float: left;
        }
        &.second {
          float: right;
        }
      }
    }
    .select-wrapper {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 38px;
      &.time-first {
        padding-right: 5px;
        // width: 45%;
      }
      &.time-second {
        padding-left: 5px;
        // width: 45%;
      }
      &:after {
        content: "\0025BC";
        // font: normal normal normal 12px/1 FontAwesome;
        color: #969696;
        right: 15px;
        top: -10px;
        height: 26px;
        padding: 15px 0px 0px 8px;
        position: absolute;
        pointer-events: none;
      }
      select {
        height: 38px;
        width: 100%;
        padding-right: 24px;
        background-color: #fff;
        border-radius: 5px;
        border-color: #969696;
        font-size: 18px;
        text-align: center;
        color: #969696;
        // margin: 3px;
        padding: 3px;
        -webkit-appearance: none;
        &.first-hours {
          // width: 50%;
          &:after {
            // right: 55%;
          }
        }
        &:focus {
          outline: none;
        }
      }
    }
  }

  .el-message-box-mobile {
    width: 98%;
  }

</style>



// WEBPACK FOOTER //
// src/components/FerieMobile/RiepilogoFerieMobile5.vue